import NewBattery from './NewBattery.vue'

export { ARROW_POSITIONS } from './components/Arrow'

export default NewBattery
